import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "level" }
const _hoisted_4 = { class: "level-left" }
const _hoisted_5 = { class: "level-item" }
const _hoisted_6 = { class: "title is-1" }
const _hoisted_7 = { class: "level-right" }
const _hoisted_8 = { class: "level-item" }
const _hoisted_9 = { class: "tag is-success is-medium mr-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-share-square" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "columns is-multiline"
}
const _hoisted_14 = { class: "column is-4" }
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any) {
  const _component_PostComponent = _resolveComponent("PostComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.page_name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.page == null ? '-' : _ctx.page.visits) + " views ", 1),
            (!_ctx.copied)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.click_share && _ctx.click_share(...args)))
                }, _hoisted_11))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.click_share && _ctx.click_share(...args)))
                }, "copied"))
          ])
        ])
      ]),
      _hoisted_12,
      _createElementVNode("div", null, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.page?.posts, (p, index) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_PostComponent, { slot: index }, null, 8, ["slot"])
                ]))
              }), 256))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, "loading.."))
      ])
    ])
  ]))
}